/*@flow*/
// import type { Map } from 'immutable';
import intersectGeoJSON from 'lib/intersectGeoJSON';

export default (v: any): any => {
  const queryUpdater = query => {
    // Generate the intersection query with geojson
    const geojson = v.get('geojson');
    return intersectGeoJSON({ query, geojson });
  };
  const mapFn = v3 => v3.updateIn(['params', 'query'], queryUpdater);
  const updateFn = v2 => v2.map(mapFn);
  return v.updateIn(['mapConfig', 'analyses'], updateFn);
};
